//Quick View 
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView(); 
  }); 
  $(document).on('click', 'body', function(){
    $('#page-transition-overlay').removeClass('active');
  });
  $(document).on('click', 'a.fancybox-item.fancybox-close', function(){
    $('#page-transition-overlay').removeClass('active');
  });

  $(document).on('click', '.gallery-cell', function(){
    $(this).addClass('active').siblings().removeClass('active');
  });
}); 
 

function quickView() {

  $(document).on('click', '.quick-view', function (event) {
    event.preventDefault();
    var getRegularDes = $(this).attr('data-regular-description');
    
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}

    var product_handle = $(this).data('handle');

    $('#quick-view').addClass(product_handle);

    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

      var title = product.title;
      var price = 0;
      var original_price = 0;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
  console.log(images)
      $('.qv-product-title').text(title); 
      $('.qv-product-description').html(getRegularDes);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;

      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div class="gallery-cell"><img class="lazyload" data-src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
         // $('.qv-product-slider').append(image_embed);
        //  $('.qv-product-slider-thumb').append(image_embed);
           $('.qv-product-images').css('opacity', '1');


 /*  $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1'); */

          $('.qv-product-images').slick({
              arrows: false,  
              speed: 500,
              autoplay: true,
              autoplaySpeed: 2000,
              slidesToShow: 2,
              slidesToScroll: 1,
              asNavFor: '.qv-product-slider-thumb',
              infinite: true
          }).css('opacity', '1');
          $('.qv-product-slider-thumb').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: false, 
              asNavFor: '.qv-product-images',
              dots: false, 
              focusOnSelect: true,
              infinite: false
          }).css('opacity', '1');
        
          
        } else {
          image_embed = '<div class="gallery-cell"><img class="lazyload" data-src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
          $('.qv-product-images').append(image_embed);
           $('.qv-product-slider-thumb').append(image_embed);
        }



        
      });

      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase().replace(' ', '-');     
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase().replace(' ', '-') + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase().replace(' ', '-') + '"></select></div>');

        $(option.values).each(function (i, value) {          
          $(selectClass).append('<option value="' + value + '">' + value + '</option>');
        });
      });

      $(product.variants).each(function (i, v) { 
        if (v.available == false) {
          $('.qv-add-button').prop('disabled', true).val('Out of Stock');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Out of Stock').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }

          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });
 

    $(document).on("change", "#quick-view select", function () {
      var $productForm = $('#product-id-'+product_handle);
      var variantInventory = $productForm.data('variant-inventory'); 
      
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {   
          
              if (v.title == selectedOptions) {
                var price = parseFloat(v.price / 100).toFixed(2);
                var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                var v_qty = v_qty;
                var v_inv = v.inventory_management;
                var v_available = v.available; 
                var v_id = v.id;  

                if (variantInventory) {
                  variantInventory.forEach(function(variant){ 
                    if (v_id === variant.id) { 
                      var variant_qty = Number(variant.inventory_quantity); 
                    console.log(variant.inventory_quantity);
                      if(variant_qty < 5){
                        $('.items_left').text(variant_qty + ' items left');
                          $('.items_left').show();
                      }else{
                        $('.items_left').hide();
                      }
                    } 
                  });
                }
                
                $('.qv-product-price').text('$' + price);
                $('.qv-product-original-price').text('$' + original_price);
                if (v_inv == null) {
                  $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                } else { 
                  if (v_available == false) { 
                    $('.qv-add-button').prop('disabled', true).val('Out of Stock');
                  } else {
                    $('.qv-add-button').prop('disabled', false).val('Add to Cart');
                  }
                }
              } 
        });
      });
    });

    $.fancybox({
      href: '#quick-view',
      maxWidth: 820,
      maxHeight: 500,
      fitToView: true,
      width: '820',
      height: '500',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val(); 
            } else { 
              selectedOptions = selectedOptions + ' / ' + $(this).val(); 
            } 
          });

          jQuery.getJSON('/products/' + product_handle + '.js', function (product) { 
            $(product.variants).each(function (i, v) { 
              if (v.title == selectedOptions) { 
                var_id = v.id; 
                processCart(var_id); 
                $('body').attr('data-custom-varid',var_id);
              } 
            }); 
          });

          function processCart(var_id) {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
            null,
             "json"
           ).done(function (cart) {
              //  $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
               $('.quick_add_btn').addClass('checkmark-active');
                $('body').addClass('openDrawerCart');
                setTimeout(function() {
                  $('a.fancybox-item.fancybox-close').trigger('click');
                  $('.icon-cart.header__icon-touch').addClass('productAdded');
                }, 2000);
                setTimeout(function() {
                  $('.icon-cart.header__icon-touch').removeClass('productAdded');
                }, 6000);
            })
              .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
          });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });   
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});

 
 